import React, { Component } from 'react';
import { Utils } from '../../utils/utils';
import { UsersService } from '../../services/user';
import Logo from "./logo.png";
import AvatarDefault from './default-avatar.png';

import './header.css';

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.openHome = this.openHome.bind(this);

    this.state = {
      "render_dropdown": false,
      "logotype": null
    }
  }

  componentWillMount() {
    this.setLogotype();
  }
  
  openHome() {
    window.location = window.location.origin + window.location.pathname + "#/";
  }

  async signOut() {
    window.localStorage.clear()
    await UsersService.signOut()
    window.location = window.location.origin + window.location.pathname + "#/";
  }

  setLogotype() {
    this.setState({
      "logotype": Utils.getCustomizationConfig("header", "logotype")
    })
  }

  getLogotypeStyle() {
    var style = {};
    var logotype = this.state.logotype;
    if (logotype) {
      // style.backgroundImage = `url(${logotype})`
      style.backgroundImage = `url(${Logo})`
    };

    return style;
  }

  render() {
    return (
      <div role="banner" className="rdp-react-template-component-header">
        {/* <div style={{display: "flex", gap: "10px"}}>
          <div className="rdp-react-template-component-header-icon" style={this.getLogotypeStyle()}></div>
          <div className="rdp-react-template-component-header-picker">Graduação</div>
        </div> */}
        <span aria-label="Logotipo Editora Senac São Paulo" className="rdp-react-template-component-header-logo" style={this.getLogotypeStyle()} onClick={() => this.openHome()}></span>
        <div
          role="button"
          aria-haspopup="true"
          aria-expanded={this.state.render_dropdown}
          aria-label="Abrir menu do usuário"
          className="rdp-react-template-component-header-item"
          onClick={() => this.setState({"render_dropdown": true})}
        >
          <div className="rdp-react-template-component-header-data">
            <span aria-hidden="true" className="rdp-react-template-component-header-first-text">Olá, {this.props.name}</span>
            <span aria-hidden="true" className="rdp-react-template-component-header-second-text">{this.props.level}</span>
          </div>
          <img 
            className="rdp-react-template-component-header-user-avatar"
            alt="Foto de Perfil"
            src={this.props.avatar} 
            onError={e => {
              e.target.src = AvatarDefault
            }} 
          />
          {/* <span className="rdp-react-template-component-header-avatar" style={{ 
            ...(this.props.avatar && {
              backgroundImage: `url("${this.props.avatar}")`
            })
          }}></span> */}
        </div>
        {/* <div className="rdp-react-template-component-header-item right" onClick={() => this.props.onCoinsClick && this.props.onCoinsClick()}>
          <span className="rdp-react-template-component-header-coin"></span>
          <div className="rdp-react-template-component-header-data">
            <span className="rdp-react-template-component-header-first-text">{this.props.coins}</span>
            <span className="rdp-react-template-component-header-second-text">{this.props.coinsLabel}</span>
          </div>
        </div> */}

        {this.state.render_dropdown &&
          <div className="rdp-react-template-component-header-dropdown-view">
            <div aria-hidden="true" className="rdp-react-template-component-header-dropdown-overlay" onClick={() => this.setState({"render_dropdown": false})}></div>
            <ul className="rdp-react-template-component-header-dropdown-items" role="menu" aria-label="Menu do usuário">
              <li role="menuitem" tabIndex="0" aria-label="Editar Perfil" className="rdp-react-template-component-header-dropdown-item" onClick={this.props.onEditClick}>Editar Perfil</li>
              <li role="menuitem" tabIndex="0" aria-label="Realizar Logout" className="rdp-react-template-component-header-dropdown-item" onClick={() => this.signOut()}>Sair</li>
            </ul>
          </div>
        }
      </div>
    );
  }
}
